import { buildGraphqlQuery } from '@ztechapps/common.utils'

const documentFragment = `
    _id
    name
    value
    description
    isDefault
    filter
    category
    scope {
      key
    }
    `

export const queries = buildGraphqlQuery('Template', documentFragment)
